<template>
    <el-form label-width="120px" class="manul-form">
        <el-form-item label="委托价格($)">
            <el-input v-model="manualParam.price"></el-input>
        </el-form-item>
        <el-form-item label="合约类型">
            <el-select v-model="manualParam.type" placeholder="请选择合约类型" @change="tradeChangeEvent">
                <el-option v-for="(trade, index) in tradeTypeObj" :key="'trade'+index" :label="trade" :value="index"
                :disabled="isBan(index)"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="委托量(张)">
            <el-input v-model="manualParam.amount" placeholder="期货时，单位为张，现货为颗"></el-input>
        </el-form-item>
        <el-form-item label="交易类型">
            <el-select v-model="manualParam.direction" placeholder="请选择交易类型">
                <el-option v-for="(trade, index) in tradeDirection" :key="'trade'+index" :label="index" :value="trade"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="币对">
            <!-- <el-input class="match_input" v-model="manualParam.symbol" @input="matchValue" @blur="loseForce"
            placeholder="请输入币对"></el-input>
            <ul class="input_dropdown" style="display: none;">
                <li v-for="(i, index) in currencyMatchList" :key="'match_'+index" 
                @click="currencySelect(i)">{{i}}</li>
            </ul> -->

            <el-input class="match_input" v-model="manualParam.symbol" placeholder="请输入币对"></el-input>
        </el-form-item>
        <el-form-item label="下单方式">
            <el-select v-model="manualParam.way" placeholder="请选择交易方向">
                <el-option label="市价" value="1"></el-option>
                <el-option label="限价" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item class="form_btn">
            <el-button class="el-button btn__style el-button--default el-button--small"
            @click="handleCommit">提交</el-button>
            <!-- <el-button class="el-button btn__style el-button--default el-button--small">重置</el-button> -->
        </el-form-item>
    </el-form>
</template>

<script>
import { mapState } from "vuex";
import { getManulCurrency, postManulData } from "@/api/api.js";

export default {
    data: function () {
        return {
            manualParam: {},
            tradeDirection: ''
        }
    },
    props: {
        apiId: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapState([
            "tradeTypeObj",
            "token"
        ]),
    },
    methods: {
        tradeChangeEvent(e) {// 交易类型 切换事件
            if (e == 'SS') {// 现货
                this.tradeDirection = {"买": 1, "卖": 2};
            } else {
                this.tradeDirection = {'开多': 1,"开空": 2, "平多": 3, "平空": 4};
            }

            if (this.type == 'temp') {
                this.getCurrencys(e);
            } 
        },

        getCurrencys(tps) {// 获取币对
            var param = {
                "bourse": this.apiData.name,
                "types": tps
            };
            getManulCurrency(param).then(res => {
                if (res.code == 200) {
                    this.currencys = res.data;
                    console.log('currencys', this.currencys);
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 100
                    });
                }
            });
        },
        isBan(col) {// 交易类型下拉框禁止选择
            if (col == 'CQ') {// 季度
                return false;
            } else {
                return true;
            }
        },
        handleCommit() {// 手动提交
            this.$confirm('是否确认手动交易？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.manualParam.apiId = this.apiId;

                postManulData(this.manualParam).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: res.info
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.info
                        });
                    }
                })
                .catch(err => {
                    console.warn('err', res);
                })
                
            }).catch(() => {

            })
            

        }
    }
}
</script>

<style lang="scss">
.manul-form{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    .el-input__inner{
        background-color: #3e403f;
        border: 1px solid #3e403f;
    }
    .el-input.is-disabled .el-input__inner{
        background-color: #3e403f;
        border-color: #3e403f;
    }
    .el-form-item{
        width: 45%;
    }
    .el-form-item__content {
        text-align: left !important;
    }
    .form_btn{
        position: absolute;
        bottom: -40px;
        right: 0px;
    }
}

.el-select-dropdown {
    background-color: #2a2d2e;
    border: 1px solid #2a2d2e;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover,
.el-select-dropdown__item.is-disabled:hover{
    background-color: #3e403f;
    color: #9a9696;
}
.el-select-dropdown__item.is-disabled{
    color: #65615f;
}
.el-select .el-input__inner:focus,
.el-select .el-input.is-focus .el-input__inner{
    border-color: #2a2d2e;
}

input::-webkit-input-placeholder { 
    /* WebKit browsers */ 
    color: #909399 !important; 
} 
</style>

